// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import API from '../api/axios';
// import { useCart } from '../context/CartContext';
// import Footer from '../components/Footer';
// import '../style/ProductDetail.css';
// import { useTheme } from '../context/ThemeContext';

// export default function ProductDetail() {
//   const { id } = useParams();
//   const [product, setProduct] = useState(null);
//   const [qty, setQty] = useState("1"); // Keep as string for smooth input
//   const { addToCart } = useCart();
//   const { darkMode } = useTheme();
//   const [isExpanded, setIsExpanded] = useState(false);

//   useEffect(() => {
//     const fetchProduct = async () => {
//       try {
//         const res = await API.get(`/products/${id}`);
//         setProduct(res.data);
//       } catch (err) {
//         console.error("Product fetch failed", err);
//       }
//     };
//     fetchProduct();
//   }, [id]);

//   if (!product) return <p className='product-loading'>Loading...</p>;

//   const weightPerUnit = product.weightPerUnit || 0;
//   const numericQty = qty === "" ? 1 : parseInt(qty, 10);
//   const totalWeight = numericQty * weightPerUnit;

//   // Handle quantity input change
//   const handleQtyChange = (e) => {
//     let value = e.target.value;
//     if (value === "") {
//       setQty(""); // allow deletion
//       return;
//     }
//     if (/^\d+$/.test(value)) {
//       if (parseInt(value, 10) > product.stock) {
//         setQty(product.stock.toString());
//       } else {
//         setQty(value);
//       }
//     }
//   };

//   return (
//     <div className={`product-detail-page ${darkMode ? 'dark' : 'light'}`}>
//       <div className="product-container">
//         {/* Left Section: Image */}
//         <div className="product-image">
//           <img src={product.image} alt={product.name} />
//         </div>

//         {/* Right Section: Info */}
//         <div className="product-info">
//           <h1>{product.name}</h1>

//           {/* Price */}
//           <p className="product-price">₹{product.price}</p>

//           {/* Description */}
//           <div className="product-description">
//             {product.description.length > 300 ? (
//               <>
//                 {isExpanded ? product.description : `${product.description.slice(0, 300)}... `}
//                 <span
//                   onClick={() => setIsExpanded(!isExpanded)}
//                   className="read-toggle"
//                 >
//                   {isExpanded ? "See Less ▲" : "Read More ▼"}
//                 </span>
//               </>
//             ) : (
//               product.description
//             )}
//           </div>

//           {/* Weight Info */}
//           {weightPerUnit > 0 && (
//             <p className="product-weight">📦 {weightPerUnit}g per unit</p>
//           )}

//           {/* Stock & Quantity */}
//           {product.stock > 0 ? (
//             <>
//               <label className="product-qty">
//                 Qty:
//                 <input
//                   type="number"
//                   value={qty}
//                   min="1"
//                   max={product.stock}
//                   onChange={handleQtyChange}
//                   inputMode="numeric"
//                 />
//               </label>

//               <div className="product-buttons">
//                 <button
//                   className="add-to-cart-btn"
//                   onClick={() =>
//                     addToCart(
//                       product,
//                       { ...product, totalWeight },
//                       numericQty
//                     )
//                   }
//                 >
//                   🛒 Add to Cart
//                 </button>
//                 {/* <button className="buy-now-btn">
//                   ⚡ Buy Now
//                 </button> */}
//               </div>
//             </>
//           ) : (
//             <p className="out-of-stock">❌ Out of Stock</p>
//           )}
//         </div>
//       </div>

//       <div style={{ marginTop: '5rem' }}>
//         <Footer />
//       </div>
//     </div>
//   );
// }


// Updated Code for resending the input
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import API from '../api/axios';
import { useCart } from '../context/CartContext';
import Footer from '../components/Footer';
import '../style/ProductDetail.css';
import { useTheme } from '../context/ThemeContext';

export default function ProductDetail() {
  const { id } = useParams();
  const { cart, addToCart, updateQty } = useCart(); // include cart and updateQty
  const { darkMode } = useTheme();
  const [product, setProduct] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);

  // Pre-fill quantity from cart if exists
  const existingCartItem = cart.find(item => item._id === id);
  const [qty, setQty] = useState(existingCartItem ? existingCartItem.qty.toString() : "1");

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await API.get(`/products/${id}`);
        setProduct(res.data);
      } catch (err) {
        console.error("Product fetch failed", err);
      }
    };
    fetchProduct();
  }, [id]);

  if (!product) return <p className='product-loading'>Loading...</p>;

  const weightPerUnit = product.weightPerUnit || 0;
  const numericQty = qty === "" ? 1 : parseInt(qty, 10);
  const totalWeight = numericQty * weightPerUnit;

  // Handle quantity input change
  const handleQtyChange = (e) => {
    let value = e.target.value;
    if (value === "") {
      setQty(""); // allow deletion
      return;
    }
    if (/^\d+$/.test(value)) {
      if (parseInt(value, 10) > product.stock) {
        setQty(product.stock.toString());
        updateQty(product._id, product.stock); // update immediately
      } else {
        setQty(value);
        updateQty(product._id, parseInt(value, 10)); // update immediately
      }
    }
  };

  const handleAddToCart = () => {
    addToCart(product, { ...product, totalWeight }, numericQty);
  };

  return (
    <div className={`product-detail-page ${darkMode ? 'dark' : 'light'}`}>
      <div className="product-container">
        <div className="product-image">
          <img src={product.image} alt={product.name} />
        </div>

        <div className="product-info">
          <h1>{product.name}</h1>
          <p className="product-price">₹{product.price}</p>

          <div className="product-description">
            {product.description.length > 300 ? (
              <>
                {isExpanded ? product.description : `${product.description.slice(0, 300)}... `}
                <span
                  onClick={() => setIsExpanded(!isExpanded)}
                  className="read-toggle"
                >
                  {isExpanded ? "See Less ▲" : "Read More ▼"}
                </span>
              </>
            ) : product.description}
          </div>

          {weightPerUnit > 0 && <p className="product-weight">📦 {weightPerUnit}g per unit</p>}

          {product.stock > 0 ? (
            <>
              {/* <label className="product-qty">
                Qty:
                <input
                  type="number"
                  value={qty}
                  min="1"
                  max={product.stock}
                  onChange={handleQtyChange}
                  inputMode="numeric"
                />
              </label> */}

              <div className="product-buttons">
                <button className="add-to-cart-btn" onClick={handleAddToCart}>
                  🛒 Add to Cart
                </button>
              </div>
            </>
          ) : (
            <p className="out-of-stock">❌ Out of Stock</p>
          )}
        </div>
      </div>

      <div style={{ marginTop: '5rem' }}>
        <Footer />
      </div>
    </div>
  );
}
